import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from './types';

export enum IChannelStatus {
    Undef = 0,
    Active = 1,
    Expired = 2,
    LastValue = 3,
}

export interface IChannelEventMap {
    Error: (error: Error) => void;
    NewMessage: (message: unknown) => void;
    StatusChanged: (newStatus: IChannelStatus) => void;
}

export interface IChannelPort {
    postMessage: (key: string, message: unknown) => void;
    postMessageRequest: (callback: (key: string, message: unknown) => void) => void;
    onMessageResponse: (callback: (key: string, message: unknown) => void) => void;
}

export type IChannelID = string;

export interface IChannel {
    id: () => IChannelID;
    status: () => IChannelStatus;
    postMessage: (message: unknown) => void;
    addEventListener: <
        Event extends keyof IChannelEventMap,
        Callback extends IChannelEventMap[Event],
    >(
        key: string,
        event: Event,
        callback: Callback,
    ) => void;
    removeListener: <Event extends keyof IChannelEventMap>(key: string, event: Event) => void;
    terminate: () => void;
}

export interface IChannelController {
    channel: (key: IChannelID) => IChannel;
    all: () => IChannel[];
}

export function injectChannelController(
    container: IContainer = injectOrBuildContainer(),
): IChannelController {
    return container.get<IChannelController>(TYPES.IChannelController);
}

export function bindChannelController(
    val: IChannelController,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IChannelController>(TYPES.IChannelController, val);
}

export function unbindChannelController(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IChannelController);
}
